import React, { FC } from 'react';
import getClassName from 'src/common/utils/getClassName';
import s from './UnreadIndicator.module.scss';

type UnreadIndicatorProps = {
  classNameModifier?: 'cappedCount' | 'inFilter' | 'inNav' | 'inNav cappedCount';
  /* Formatted number of unread messages shown in the badge. */
  unreadCountLabel?: string;
};

const UnreadIndicator: FC<UnreadIndicatorProps> = ({
  classNameModifier,
  unreadCountLabel,
}) => (
  <div
    className={getClassName(s, 'root', classNameModifier)}
    aria-label={
      // If `unreadCountLabel` is undefined, it means there is at least one unread message,
      // but we don't want to specify the exact number (since we show a generic badge in that case).
      // If `unreadCountLabel` is defined (e.g., "2"  or "99+"), we render it directly.
      unreadCountLabel === undefined
        ? '1 unread message'
        : `${unreadCountLabel} unread messages`
    }
  >
    {unreadCountLabel}
  </div>
);

export default UnreadIndicator;
